import Vue from 'vue';
import dayjs from 'dayjs';

Vue.filter('date', val => dayjs(val).format('lll'));
Vue.filter('date-compact', val => dayjs(val).format('l'));
